/// <amd-module name="WidgetCommon/ModernWidgetTypes/WidgetMessageCardFactory" />
import "VSS/LoaderPlugins/Css!widgets";

import * as React from "react";
import { Size } from "Reporting/Visuals/LayoutComponents/Widgets/ComponentLayoutEngine";
import { MessageType } from "Reporting/Visuals/LayoutComponents/Widgets/LayoutState";
import { ActionRequiredContent } from "Reporting/Visuals/VisualMessages/ActionRequiredContent";
import { AxFaultInMessage } from "Reporting/Visuals/VisualMessages/AxFaultInMessage";
import { NoDataMessage } from "Reporting/Visuals/VisualMessages/NoDataMessage";
import { UnconfiguredMessage } from "Reporting/Visuals/VisualMessages/UnconfiguredMessage";
import { VisualMessageAction } from "Reporting/Visuals/VisualMessages/VisualMessageBase";
import { SetIterationDatesMessage } from "WidgetCommon/IterationDatesMessage/SetIterationDatesMessage";

// This file encapsulates responsibility for generating Widget Message Cards, as a generalization from Velocity widget message presentatio code.
// Ultimately, this layer should be factorable to a responsibility of Widget Components.

/** Options for configuring the action of a card. */
export interface ActionMessageOptions {
    actionText: string;
    actionAriaLabel: string;
    actionOnClickDelegate: () => void;
}

export interface MessageOptions extends ActionMessageOptions {}

export interface MessageCardOptions {
    /* Detailed error message */
    message?: string;

    /* Type of message to be displayed */
    messageType?: MessageType;

    /** Additional options for particular message types. */
    messageOptions?: MessageOptions;
}

export interface WidgetMessageCardFactoryProps extends MessageCardOptions {
    /* Title of widget */
    title: string;

    /* Size of widget */
    size: Size;

    /* Suppress title of widget*/
    hideTitle?: boolean;
}

export interface WidgetMessageCardFactoryState {}

/* Gets MessageType from BaseViewComponent and returns WidgetMessageCardProps */
export class WidgetMessageCardFactory extends React.Component<WidgetMessageCardFactoryProps, WidgetMessageCardFactoryState> {
    public constructor(props: WidgetMessageCardFactoryProps) {
        super(props);
    }

    public render(): JSX.Element {
        const messageCard = this.getMessageCard();

        return <div className="widget-message-card-container">{messageCard}</div>;
    }

    private getMessageCard(): JSX.Element | null {
        switch (this.props.messageType) {
            case MessageType.NoData: {
                return <NoDataMessage visualTitle={this.props.title} size={this.props.size} hideTitle={this.props.hideTitle} />;
            }

            case MessageType.SetIterationDates: {
                return <SetIterationDatesMessage visualTitle={this.props.title} actionOptions={this.getWidgetCardAction()} size={this.props.size} />;
            }

            case MessageType.AxFaultIn: {
                return <AxFaultInMessage visualTitle={this.props.title} size={this.props.size} />;
            }

            case MessageType.Unconfigured: {
                return <UnconfiguredMessage visualTitle={this.props.title} size={this.props.size} onClick={this.getWidgetCardAction().onClick} />;
            }

            case MessageType.MissingPermissions: {
                return <ActionRequiredContent visualTitle={this.props.title} onClick={this.getWidgetCardAction().onClick} />;
            }

            default: {
                return null;
            }
        }
    }

    private getWidgetCardAction(): VisualMessageAction {
        return {
            text: this.props.messageOptions ? this.props.messageOptions.actionText : "",
            ariaLabel: this.props.messageOptions ? this.props.messageOptions.actionAriaLabel : "",
            onClick: this.props.messageOptions ? this.props.messageOptions.actionOnClickDelegate : undefined
        };
    }
}
